export interface PickupLocationInfo {
    /**
     * 受け取り場所のタイプ
     */
    locationType: PickupLocationType
    /**
     * 住所
     */
    address: string,
    /**
     * ラベル(わかりやすい場所：例、xxxの公民館)
     */
    label: string,
    /**
     * GoogleMapのURL
     */
    googleMapURL: string,
    /**
     * 場所の写真のURL1
     */
    siteURL1?: string,
    /**
     * 場所の写真のURL2
     */
    siteURL2?: string,
    /**
     * 場所の写真のURL3
     */
    siteURL3?: string,
    /**
     * 場所の写真のURL4
     */
    siteURL4?: string,
}


/**
 * 受け取り場所
 */
export const PickupLocationType = {
    ArrivalPort: "ArrivalPort",
    Home: "Home"
} as const;
export type PickupLocationType = typeof PickupLocationType[keyof typeof PickupLocationType];